export default __webpack_public_path__ + "static/media/img-yongwang.c18b5661.png";